import { UIF_CONFIG_2024_25, UIF_ANNUAL_CAP } from '../../data/tax/uifConfig';

export function calculateUif(annualGrossIncome: number): number {
  // UIF is calculated on the capped amount
  const cappedIncome = Math.min(annualGrossIncome, UIF_ANNUAL_CAP);
  
  // Employee contributes 1% of capped income
  const uifContribution = cappedIncome * UIF_CONFIG_2024_25.employeeRate;
  
  return Math.round(uifContribution * 100) / 100; // Round to 2 decimal places
}

export function calculateMonthlyUif(monthlyGrossIncome: number): number {
  // UIF is calculated on the capped monthly amount
  const cappedMonthlyIncome = Math.min(monthlyGrossIncome, UIF_CONFIG_2024_25.monthlyCapAmount);
  
  // Employee contributes 1% of capped income
  const monthlyUifContribution = cappedMonthlyIncome * UIF_CONFIG_2024_25.employeeRate;
  
  return Math.round(monthlyUifContribution * 100) / 100; // Round to 2 decimal places
}

export function getMaxAnnualUifContribution(): number {
  return UIF_ANNUAL_CAP * UIF_CONFIG_2024_25.employeeRate;
}

export function getMaxMonthlyUifContribution(): number {
  return UIF_CONFIG_2024_25.monthlyCapAmount * UIF_CONFIG_2024_25.employeeRate;
}